export class AnswersKey {
  id: string;
  value: string;
}
